module.exports = __webpack_public_path__ + "static/media/backgroundFootball_Dark.aa294aff.svg";